import { useEffect } from 'react'
import { ContentSteps } from 'src/lib/useStepFlow'

import styles from './styles.module.scss'
import { MovingHorizontalDots } from '../../dots/horizontal/MovingHorizontalDots'
import { MovingVerticalDots } from '../../dots/vertical/MovingVerticalDots'
import AirPlane from '../../plane/Plane'
import { Counter } from '../../counter/Counter'

export type TFirstStepProps = {
    onNext: (step: ContentSteps) => void
    isStoppedCounter: boolean
    handleStoppedCounter: () => void
    step: ContentSteps
}

export const FirstStep = ({
    onNext,
    isStoppedCounter,
    handleStoppedCounter,
    step,
}: TFirstStepProps) => {
    useEffect(() => {
        if (isStoppedCounter) {
            setTimeout(() => {
                onNext(step)
            }, 2000)
        }
    }, [isStoppedCounter, onNext, step])

    return (
        <div className={styles.stepContainer}>
            <MovingHorizontalDots isStopped={isStoppedCounter} />
            <MovingVerticalDots isStopped={isStoppedCounter} />
            <div className={styles.lines}>
                <AirPlane isStopped={isStoppedCounter} />
            </div>
            <Counter
                isStopped={isStoppedCounter}
                handleStoppedCounter={handleStoppedCounter}
            />
        </div>
    )
}
